import { useMemo } from "react";
import { mixed, number, object, string } from "yup";
import { PROOF_FILE } from "consts/ecommerce";
import { fileSize, fileType } from "util/validators";
import { FormField } from "./types";

const useValidationSchema = () =>
    useMemo(() => (
        object().shape({
            [FormField.AccountHolderName]: string()
                .required()
                .trim()
                .min(1)
                .label('Account Holder Name'),
            [FormField.BankName]: string()
                .required()
                .trim()
                .min(1)
                .label('Bank Name'),
            [FormField.Iban]: string()
                .required()
                .trim()
                .label('IBAN')
                .matches(/^[A-Z]{2}\d{2}[A-Z0-9]{1,30}$/, 'Invalid IBAN format'),
            [FormField.ProofFileKey]: mixed()
                .required()
                .test('fileSize', 'File size is too large', fileSize(PROOF_FILE.maxSize))
                .test('fileType', 'Unsupported file format', fileType(PROOF_FILE.supportedFormats))
                .label('Proof of Bank Account Ownership'),
            [FormField.Swift]: string()
                .trim()
                .label('SWIFT/BIC')
                .matches(/^[A-Z]{6}[A-Z0-9]{2}([A-Z0-9]{3})?$/, 'Invalid SWIFT/BIC format'),
            [FormField.Currency]: string()
                .required()
                .nullable()
                .label('Currency'),
            [FormField.AvgTransactionSize]: number()
                .label('Average Transaction Size'),
            [FormField.MonthlyIncome]: number()
                .label('Monthly Income'),
            [FormField.TransactionVolume]: number()
                .label('Monthly Transaction Volume'),
        })
    ), []);

export default useValidationSchema;
